<template>
  <div class="fcbutton">

    <button class="btn" :disabled="disabled">{{ text }} </button>
  </div>
</template>

<script>
export default {
  name: 'Fcbutton',
  components: {},
  props: {
    text: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  created() {},
  methods: {}
}
</script>

<style scoped lang="scss">
.fcbutton{
  text-align: center;
}
 .btn{
        background: #1DD9CE;
        border-radius: 0.34rem;
        width: 5.89rem;
        height: 0.68rem;
        color:white;
        line-height: 0.68rem;
        border: none;
        font-size: 0.24rem !important;

    }
    .btn:active{
        background: #1bbfb6;
    }
      button:disabled {
       background: #c1c1c1;
   }
</style>
